import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
    fetchCarlaoNotifications,
    markCarlaoNotificationRead,
} from '../services/carlao-notifications.service'

export function useCarlaoNotifications(page = 1, perPage = 20) {
    return useQuery({
        queryKey: ['carlao-notifications', page, perPage],
        queryFn: () => fetchCarlaoNotifications(page, perPage),
        // Polling leve a cada 60s pro sininho atualizar sem precisar de WebSocket
        refetchInterval: 60 * 1000,
        staleTime: 30 * 1000,
    })
}

export function useMarkNotificationRead() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: number) => markCarlaoNotificationRead(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['carlao-notifications'] })
        },
    })
}
